import client from '../api/client.js'

export const fetchMyOrganizationsRequest = async () => {
  const response = await client.get('/organizations/my')
  return response?.data
}

export const fetchAllOrganizationsRequest = async (status = 'active') => {
  const response = await client.get('/organizations/', {
    params: status ? { status } : undefined,
  })
  return response?.data
}

export const fetchSubOrgsRequest = async (status = 'active') => {
  const response = await client.get('/suborgs/', {
    params: status ? { status } : undefined,
  })
  return response?.data
}

export const createSubOrgRequest = async (name, description = '', organization_id) => {
  const response = await client.post('/suborgs/', { name, description, organization_id })
  return response?.data
}

export const updateSubOrgRequest = async (subOrgId, name, description = '') => {
  const response = await client.put(`/suborgs/${subOrgId}`, { name, description })
  return response?.data
}

export const deleteSubOrgRequest = async (subOrgId) => {
  await client.delete(`/suborgs/${subOrgId}`)
  return true
}

export const addSubOrgMemberRequest = async (subOrgId, userId, role) => {
  const response = await client.post(`/suborgs/${subOrgId}/members`, { user_id: userId, role })
  return response?.data
}

export const listUserSubOrgsRequest = async (userId) => {
  const response = await client.get(`/users/${userId}/suborgs`)
  return response?.data
}

export const addUserSubOrgMembershipRequest = async (userId, subOrgId, role = 'user') => {
  const response = await client.post(`/users/${userId}/suborgs`, { sub_org_id: subOrgId, role })
  return response?.data
}

export const removeUserSubOrgMembershipRequest = async (userId, subOrgId) => {
  await client.delete(`/users/${userId}/suborgs/${subOrgId}`)
  return true
}

export const createOrganizationRequest = async (payload) => {
  const response = await client.post('/organizations/', payload)
  return response?.data
}

export const getDeletePreview = async (orgId) => {
  const response = await client.get(`/organizations/${orgId}/delete-preview`)
  return response?.data
}

export const softDeleteOrganization = async (orgId, payload = {}) => {
  const response = await client.post(`/organizations/${orgId}/soft-delete`, payload)
  return response?.data
}

export const restoreOrganization = async (orgId) => {
  const response = await client.post(`/organizations/${orgId}/restore`)
  return response?.data
}

export const restoreSubOrgRequest = async (subOrgId) => {
  const response = await client.post(`/suborgs/${subOrgId}/restore`)
  return response?.data
}

export const softDeleteSubOrg = async (subOrgId, payload = {}) => {
  const response = await client.post(`/suborgs/${subOrgId}/soft-delete`, payload)
  return response?.data
}

